import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import api from "../../api/axiosInstance";
const GenerateExternalForm = () => {
  debugger;
  const { formMasterGuid } = useParams();
  const [formMasterName, setFormMasterName] = useState("");
    const [blocked, setBlocked] = useState(false);
  debugger;
  useEffect(() => {
    debugger;
    const fetchFormData = async () => {
      try {
        const response = await api.get(
          `/FormMaster/ViewFormMaster/${formMasterGuid}`
        );

        console.log("Form Master Data:", response.data);
        debugger;
        // update state
        setFormMasterName(
          response.data.formMaster.name || response.data.formMaster.name || ""
        );
      } catch (error) {
        console.error("Error fetching form data", error);
      }
    };

    fetchFormData(); // call function
  }, [formMasterGuid]); // dependency

    const handleGenerateForm = async () => {
      setBlocked(true);
    debugger;
 const url=`/FormMaster/GenerateExternalForm/${formMasterGuid}`;
await api
      .post(url, {}, { headers: { "Content-Type": "application/json" } })
      .then((response) => {
        debugger;
        if (response.status === 200) {
          setBlocked(false);
          debugger;
       window.open( `/editor/ViewExternalForm/${response.data.formId}`,"_blank"); // Opens in a new tab
        }
      })
      .catch((error) => {
        setBlocked(false);
        console.error("Error copying form:", error);
        alert("Failed to Generate External form. Please check the console for details.");
      });

  };

  const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};

  return (
    <div
style={{
  
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

}}>

  {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
    <div
      style={{
        width: "30%",
        height: "40%",
        margin: "auto",
        marginTop:"30px",
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        border: "1px solid #ddd",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header */}
      <h1
        style={{
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#2528d6ff",
        }}
      >
        {formMasterName || "External Form"}
      </h1>

      {/* Submit Button */}
      <div style={{display:"flex",
        justifyContent:"center"
      }}>
        <button
          style={{
            padding: "5px 8px",
            fontSize: "16px",
            borderRadius: "6px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
          onClick={handleGenerateForm}
        >
          Generate Form
        </button>
      </div>
    </div>
    </div>
  );
};

export default GenerateExternalForm;
